import React, { useState, useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import CommandeRecap from './CommandeRecap';
import { changeValeur, useCommandeContext } from '../contexts/CommandeContext';
import { useNavigate } from 'react-router-dom';
import { useFetch } from 'use-http';
import Cookies from 'js-cookie';

export default function EtapeConfirmation() {

	const navigate = useNavigate();

	// Recupération de la commande et du dispatcher à partir du CommandeContext
	const { dispatch } = useCommandeContext();

	// Initialisation de l'accés au backend
	const { post } = useFetch(process.env.REACT_APP_BACKEND_API_URL);

	// Initialisation des messages à afficher en fonction du type de paiement
	const [title] = useState('Commande finalisée !');
	const [message] = useState('Une confirmation de votre rendez-vous, de votre paiement ainsi qu\'une facture vous seront envoyées dans quelques minutes.');

	useEffect(() => {

		// Récupération des details de la commande à partir du cookie
		let commandeDetails = Cookies.get("commandeDetails") != null ? JSON.parse(Cookies.get("commandeDetails")) : null;
		if (commandeDetails == null) {
			console.log("Redirect cause commandeDetails is null or undefined");

			navigate(process.env.REACT_APP_CATALOGUE_URL + '/');
			return;
		}

		// Récupération des autres cookies
		let commandeCreneau = JSON.parse(Cookies.get("commandeCreneau"));
		let commandeCommune = JSON.parse(Cookies.get("commandeCommune"));

		let test = false;
		// Verification si mode de test
		if (commandeDetails.contactEmail === "test@gmail.com")
			test = true;

		// Recupération montant de la commande
		let totalAmount = commandeDetails.tarif.montantTotal;
		let itemName = 'Forfait ' + commandeDetails.prestationKey.replaceAll('-', ' ')
			+ ' ' + commandeDetails.produitKey.replaceAll('-', ' ')
			+ ' ' + commandeDetails.quantiteTotale + ' unité(s)';

		// Action pour le tracker google
		// Initialisation du datalayer
		window.dataLayer = window.dataLayer || [];
		// Initialisation du datalayer
		window.dataLayer.push({ ecommerce: null });

		window.dataLayer.push({

			total_amount: totalAmount,

			event: "purchase",

			email: commandeDetails.contactEmail,
			phoneNumber: commandeDetails.contactTelephoneMobile !== "" ? commandeDetails.contactTelephoneMobile : commandeDetails.contactTelephoneFixe,
			firstName: commandeDetails.contactPrenom,
			lastName: commandeDetails.contactNom,
			addressStreet: commandeDetails.adresse,
			addressCity: commandeDetails.commune,
			addressZipCode: commandeDetails.codePostal,

			ecommerce: {
				transaction_id: commandeDetails.stripeInvoiceId,
				value: totalAmount,
				currency: "EUR",
				items: [{
					item_id: commandeDetails.prestationKey + '-' + commandeDetails.produitKey,
					item_name: itemName,
					index: 0,
					item_brand: "Ellian",
					item_category: commandeDetails.prestationKey,
					item_category2: commandeDetails.produitKey,
					price: totalAmount,
					quantity: 1
				}]
			}
		});

		// Déclaration et appel de fonction de finalisation de la commande avec le backend
		async function handleFinalizeCommande(cmdDetails) {
			await post('/commande/finalisation-commande', cmdDetails);
		}

		if (!test)
			handleFinalizeCommande(commandeDetails);

		// Remise à jour du contexte avec les données de la session
		// Afin de pouvoir les afficher sur la page de confirmation pour laquelle le contexte a été réinitialisé
		dispatch(changeValeur('quantiteTotale', commandeDetails.quantiteTotale));
		dispatch(changeValeur('dureeTotale', commandeDetails.duree));
		dispatch(changeValeur('quantiteTotaleOptions', commandeDetails.quantiteTotaleOptions));
		dispatch(changeValeur('montantOptions', commandeDetails.montantOptions));
		dispatch(changeValeur('creneau', commandeCreneau));
		dispatch(changeValeur('commune', commandeCommune));
		dispatch(changeValeur('adresse', commandeDetails.adresse));
		dispatch(changeValeur('typePaiement', commandeDetails.typePaiement));

		// Finally remove cookies
		//Cookies.remove("commandeDetails");
		//Cookies.remove("commandeCreneau");
		//Cookies.remove("commandeCommune");

		const element = document.getElementById('titreConfirmation');
		if (element) {
			element.scrollIntoView({ behavior: 'smooth' });
		}

	}, [dispatch, post, navigate]);

	return (
		<Grid container spacing={3} direction="row" justifyContent="center">

			<Grid item xs={12}>
				<Typography id="titreConfirmation" component="h3" sx={{ color: '#004afe', fontSize: { xs: 26, sm: 26, md: 36, lg: 36 }, fontWeight: 400, textAlign: 'center', my: 2 }}>
					{title}
				</Typography>
			</Grid>

			<Grid item xs={12} sm={12} md={10} lg={8} xl={8}>
				Chère cliente, cher client,<br /><br />
				Ellian vous remercie de votre commande.<br />
				{message}<br />
				Pour toute demande n'hésitez pas à contacter notre service client.<br /><br />

				Merci de votre confiance et à très bientôt pour la réalisation de votre prestation d'entretien ou de dépannage' !<br /><br />
				L'équipe Ellian.
				<br /><br />
			</Grid>

			<CommandeRecap />

		</Grid>
	);
}
